import { render, staticRenderFns } from "./my_transaction.vue?vue&type=template&id=97851e70&scoped=true"
import script from "./my_transaction.vue?vue&type=script&lang=js"
export * from "./my_transaction.vue?vue&type=script&lang=js"
import style0 from "./my_transaction.vue?vue&type=style&index=0&id=97851e70&prod&lang=less&scoped=true"
import style1 from "./my_transaction.vue?vue&type=style&index=1&id=97851e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97851e70",
  null
  
)

export default component.exports